import { Reveal, SectionHeading } from "../Reveal";
import { useContent } from "../../context/ContentContext";

export const Gallery = () => {
  const { gallery } = useContent();
  return (
    <section className="bg-navy-50/60 py-24" data-testid="gallery-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <SectionHeading eyebrow={gallery.eyebrow} title={gallery.title} desc={gallery.desc} />
        </Reveal>

        <div className="mt-12 columns-1 gap-4 sm:columns-2 lg:columns-3 [column-fill:_balance]">
          {gallery.items.map((g, i) => (
            <Reveal key={i} delay={(i % 3) * 0.08} className="mb-4 break-inside-avoid">
              <div className="group relative overflow-hidden rounded-2xl shadow-md" data-testid={`gallery-item-${i}`}>
                <img
                  src={g.url}
                  alt={g.alt}
                  loading="lazy"
                  className={`w-full object-cover transition-transform duration-500 group-hover:scale-105 ${
                    g.tall ? "h-[420px]" : "h-64"
                  }`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-navy/70 via-transparent to-transparent opacity-0 transition-opacity group-hover:opacity-100" />
                <p className="absolute bottom-4 left-4 translate-y-2 text-sm font-bold text-white opacity-0 transition-all group-hover:translate-y-0 group-hover:opacity-100">
                  {g.alt}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
